<template>
  <validation-provider
    :rules="rules"
    :name="name"
    :vid="name"
    v-slot="validation"
    tag="div"
  >
    <label
      :class="{
        [$style.container]: true,
        [$style.disabled]: disabled
      }"
      ><input
        v-model="innerValue"
        :disabled="disabled"
        type="checkbox"
        :name="name"
        :id="idFromName"
        ref="input" />
      <div :class="$style.track" />
      <div :class="$style.peg"
    /></label>
    <div :class="$style.error">{{ validation.errors[0] }}</div>
  </validation-provider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { kebabCase } from 'lodash'

export default {
  name: 'base-toggle',

  components: { ValidationProvider },

  props: {
    disabled: { Boolean, default: false },
    value: { Boolean },
    rules: { String },
    name: { String, required: true }
  },

  data: () => ({
    innerValue: null
  }),

  computed: {
    idFromName() {
      return kebabCase(this.name)
    }
  },

  watch: {
    innerValue(val) {
      this.$emit('input', val)
    },

    value(newVal) {
      // required to handle value updates from outside
      this.innerValue = newVal
    }
  },

  created() {
    // required to prefill with initial value
    this.innerValue = this.value
  }
}
</script>

<style lang="scss" module>
.container {
  display: inline-block;
  cursor: pointer;
  position: relative;
  margin: 4px 0;

  &.disabled {
    cursor: not-allowed;
  }

  &:hover .peg {
    opacity: 0.9;
  }

  [type='checkbox'] {
    visibility: hidden;
    width: 0;
    height: 0;
    position: absolute;
    margin: 0;
  }
}

.track {
  background: $color-borders-light;
  width: 34px;
  height: $size-small;
  border-radius: calc($size-small / 2);
  transition: background-color 0.3s, opacity 0.3s;

  :checked ~ & {
    background: $color-primary-light;
    opacity: 0.3;
  }

  .disabled & {
    background-color: $color-borders-light;
    opacity: 1;
  }
}

.peg {
  width: $size-small;
  height: $size-small;
  border-radius: calc($size-small / 2);
  background-color: $color-primary-light;
  transform-origin: center center;
  transform: scale(1.5);
  position: absolute;
  left: 0;
  top: 0;
  transition: left 0.3s;
  box-shadow: $shadow-small;

  .disabled & {
    background-color: #a3a4a9;
  }

  :checked ~ & {
    left: 20px;
  }
}

.error {
  font-size: $size-xx-small;
  font-weight: $weight-medium;
  line-height: $size-medium;
  letter-spacing: 0.4px;
  color: $color-danger;
  min-height: spacing(2);
  margin-left: spacing(3);
  margin-top: 2px;
  text-align: left;
}
</style>
